import MaintenancePage from 'components/maintenance/MaintenancePage';
import { RouteConfig } from '../type';

const maintenanceRoutes: RouteConfig[] = [
    { path: '', element: <MaintenancePage />, pageTitle: 'Maintenance' },
    { path: '*', element: <MaintenancePage />, pageTitle: 'Maintenance' },
];

export default maintenanceRoutes;
